import { CloseIcon } from '@sketchnote/icons';
import { Button } from '@sketchnote/shared-components';
import Tippy from '@tippyjs/react';
import React, { useCallback, useMemo } from 'react';

import { useAccountStore } from '../store';

export const LogoUpload = ({ admin }: { admin: boolean }) => {
  const { organizationLogo, setOrganizationLogo, setOrganisationLogoSize } = useAccountStore(
    (state) => state
  );

  const hiddenFileInput = React.useRef<any>(null);

  const imageURL = useMemo(() => {
    if (organizationLogo instanceof File) {
      return URL.createObjectURL(organizationLogo);
    }
  }, [organizationLogo]);

  const handleClick = useCallback(() => {
    hiddenFileInput?.current?.click();
  }, []);

  const handleFileChange = useCallback((event) => {
    if (event.target.files?.length) {
      setOrganizationLogo(event.target.files[0]);
      setOrganisationLogoSize(event.target.files[0].size);
    }
  }, []);

  return (
    <div className="mt-16">
      <span className="inline-block text-xs text-gray-600 mb-4">Company logo </span>
      <div className="flex items-center">
        {organizationLogo && organizationLogo !== 'remove_logo' ? (
          <div className=" rounded-sm border border-dashed relative group">
            <button
              onClick={() => {
                setOrganizationLogo('remove_logo');
                setOrganisationLogoSize(0);
              }}
              className="absolute -right-5 -top-7 text-xss opacity-0 group-hover:opacity-100 transition-opacity "
            >
              <CloseIcon />
            </button>
            <img
              className="object-contain w-200 h-64 object-left"
              src={
                organizationLogo
                  ? organizationLogo instanceof File
                    ? imageURL
                    : organizationLogo
                  : ''
              }
            />
          </div>
        ) : (
          <Tippy
            content="Only administrators have the permission to update the logo"
            disabled={admin}
            placement="right"
          >
            <button
              className="border-dashed border border-gray-400 w-200 h-64 rounded-sm text-gray-500 text-sm"
              onClick={handleClick}
              disabled={!admin}
            >
              <span className="text-center m-auto text-xs block">Upload logo</span>
              <span className="text-gray-400 text-xss text-center m-auto">
                Recommended dimensions 200x64
              </span>
            </button>
          </Tippy>
        )}

        <input
          ref={hiddenFileInput}
          accept="image/*"
          className="hidden"
          id="file"
          multiple={false}
          type="file"
          onChange={handleFileChange}
        />
        {organizationLogo ? (
          <Button status="ghost" className="px-12 text-xs" onClick={handleClick}>
            Upload logo
          </Button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
